import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-radius-sm text-base font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--focus-ring)] disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-primary-foreground shadow hover:bg-primary/90',
        destructive:
          'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline: 'border border-input bg-background shadow-sm',
        secondary:
          'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
        ghost:
          'hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        hoverpage: 'hover:bg-secondary-hover',
        selectpage: 'bg-pagination-active focus:bg-pagination-active',
      },
      size: {
        default: 'h-9 px-padding-xl py-padding-xl',
        sm: 'h-8 rounded-radius-sm px-padding-xl text-[0.8125rem]',
        lg: 'h-10 rounded-radius-sm px-8',
        icon: 'h-9 w-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)
